import { useEffect, useMemo } from "react";
import styles from "./AssignedLogbooks.module.scss";
import {
  type Control,
  type UseFormGetValues,
  type UseFormSetValue,
  useWatch,
} from "react-hook-form";
import CheckboxGroup from "src/components/shared/_FormInputs/CheckboxGroup/CheckboxGroup";
import {
  type IUserForm,
  type LogbookSelectItem,
} from "src/pages/Settings/CrewSetUp/UserForm/UserForm.types";
import { MEDLBID, MEDRANK } from "../../../../../utils";

interface Props {
  getValues: UseFormGetValues<IUserForm>;
  setValue: UseFormSetValue<IUserForm>;
  control: Control<IUserForm>;
  logbooks: LogbookSelectItem[];
  disabled: boolean;
  noScroll?: boolean;
}

const AssignedLogbooks = ({
  getValues,
  setValue,
  control,
  logbooks,
  disabled,
  noScroll,
}: Props) => {
  const medofficer = useWatch({ control, name: "medofficer" });
  const rank = useWatch({ control, name: "role" });

  const condition = useMemo(
    () =>
      medofficer ||
      rank === "4237f6df-5b63-94cd-8a27-71ebecf56eef" ||
      rank === "5f991ff9-3106-11ec-800f-d45d6455e22d" ||
      rank === "d66a0429-edda-11ef-85fa-00155da4b611" ||
      rank === "e0053d78-f8d3-11ee-aeab-00155d0769b9" ||
      rank === MEDRANK,
    [medofficer, rank],
  );

  const data = useMemo(
    () =>
      condition ? logbooks : logbooks.filter(log => log.value !== MEDLBID),
    [condition, logbooks],
  );
  useEffect(() => {
    if (!condition) {
      const logs = getValues("logbooks");
      if (logs && logs.length > 0) {
        setValue(
          "logbooks",
          logs.filter(log => log !== MEDLBID),
        );
      }
    }
  }, [condition, getValues, setValue]);
  return (
    <div className={styles.hoverCheckboxWrapper} style={{ width: "100%" }}>
      <CheckboxGroup
        name="logbooks"
        control={control}
        scrollHeight={500}
        data={data}
        disabled={disabled}
        searchable
        noScroll={noScroll}
      />
    </div>
  );
};

export default AssignedLogbooks;
